const regionTypes = {
    SAVE_REGION: 'SAVE_REGION',
    GET_REGIONS: 'GET_REGIONS',
    SET_REGIONS: 'SET_REGIONS',
    UPDATE_REGION: 'UPDATE_REGION',
    DELETE_REGION: 'DELETE_REGION'
};

export default regionTypes;
